import { RoutesService, eLayoutType } from '@abp/ng.core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';
import { APP_INITIALIZER } from '@angular/core';

export const SECURITY_LOGS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/security-logs',
        name: '::Menu:SecurityLogs',
        iconClass: 'fas fa-shield-alt',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.SecurityLogs',
        // Sits beside Identity Management and Settings, where an admin looks for oversight tools.
        parentName: eThemeSharedRouteNames.Administration,
        order: 5,
      },
    ]);
  };
}
